import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import "../../styles/admin/AdminSidebar.css";

function AdminSidebar() {
  const navigate = useNavigate();
  const [showSignOutModal, setShowSignOutModal] = useState(false);

  const handleLogoClick = () => {
    navigate("/admin/dashboard");
  };

  const handleSignOutClick = () => {
    setShowSignOutModal(true);
  };

  const confirmSignOut = async () => {
    try {
      await auth.signOut();
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
    } finally {
      setShowSignOutModal(false);
    }
  };

  const cancelSignOut = () => {
    setShowSignOutModal(false);
  };

  return (
    <div className="admin-sidebar">
      <div style={{ flex: 1 }}>
        <div className="logo-container" onClick={handleLogoClick}>
          <img src="/orvion-logo.png" alt="Orvion Logo" className="logo-image" />
          <h2>Orvion Admin</h2>
        </div>

        <nav className="admin-nav">
          <Link to="/admin/dashboard">Dashboard</Link>
          <Link to="/admin/users">Manage Users</Link>
          <Link to="/admin/projects">Manage Projects</Link>
          <Link to="/admin/requests">Project Requests</Link>
          <Link to="/admin/licenses">Users License</Link>
        </nav>
      </div>

      <button onClick={handleSignOutClick} className="signout-btn">Sign Out</button>

      {showSignOutModal && createPortal(
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#FFFFFF',
            padding: '24px',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '400px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            textAlign: 'center',
            position: 'relative',
            zIndex: 10000
          }}>
            <h3 style={{ margin: '0 0 16px 0', color: '#333' }}>Sign Out</h3>
            <p style={{ margin: '0 0 24px 0', color: '#666' }}>Are you sure you want to sign out?</p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={cancelSignOut}
                style={{
                  padding: '8px 20px',
                  borderRadius: '6px',
                  border: '1px solid #ddd',
                  background: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  color: '#666'
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmSignOut}
                style={{
                  padding: '8px 20px',
                  borderRadius: '6px',
                  border: 'none',
                  background: '#ff4d4f',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

export default AdminSidebar;
